import { render, staticRenderFns } from "./ListMedpupille.vue?vue&type=template&id=cb2a18d4&"
import script from "./ListMedpupille.vue?vue&type=script&lang=js&"
export * from "./ListMedpupille.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports